import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppAuthProvider } from "@/context/AppAuthContext";
import { CategoriesProvider } from "@/context/CategoriesContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import SubmitSignal from "@/pages/SubmitSignal";
import SubmitListing from "@/pages/SubmitListing";
import ListingsPage from "@/pages/ListingsPage";
import ListingDetail from "@/pages/ListingDetail";
import Auth from "@/pages/account/Auth";
import AuthCallback from "@/pages/account/AuthCallback";
import VerifyEmail from "@/pages/account/VerifyEmail";
import ForgotPassword from "@/pages/account/ForgotPassword";
import ResetPassword from "@/pages/account/ResetPassword";
import Profile from "@/pages/account/Profile";
import About from "@/pages/About";
import Contacts from "@/pages/Contacts";
import StaticPage from "@/pages/StaticPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";
import MaintenancePage from "@/pages/MaintenancePage";

function MaintenanceGate({ children }) {
  const settings = useSettings();
  const { user } = useAuth();
  const location = useLocation();
  const isAdminArea = location.pathname.startsWith("/admin");
  const isStaff = !!(user && user.role);
  const previewMaintenance =
    new URLSearchParams(location.search).get("preview") === "maintenance";
  if (previewMaintenance && !isAdminArea) {
    return <MaintenancePage preview />;
  }
  if (settings.maintenance_mode && !isAdminArea && !isStaff) {
    return <MaintenancePage />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppAuthProvider>
        <SettingsProvider>
          <CategoriesProvider>
            <BrowserRouter>
              <MaintenanceGate>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/article/:slug" element={<ArticlePage />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/izprati-signal" element={<SubmitSignal />} />
                <Route path="/obyavi" element={<ListingsPage />} />
                <Route path="/publikuvai-obyava" element={<SubmitListing />} />
                <Route path="/obyava/:slug" element={<ListingDetail />} />
                <Route path="/vhod" element={<Auth mode="login" />} />
                <Route path="/registraciya" element={<Auth mode="register" />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/zabravena-parola" element={<ForgotPassword />} />
                <Route path="/reset-parola" element={<ResetPassword />} />
                <Route path="/profil" element={<Profile />} />
                <Route path="/za-nas" element={<About />} />
                <Route path="/kontakti" element={<Contacts />} />
                <Route path="/obshti-usloviya" element={<StaticPage kind="terms" />} />
                <Route path="/poveritelnost" element={<StaticPage kind="privacy" />} />
                <Route path="/admin/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
              </MaintenanceGate>
            </BrowserRouter>
          </CategoriesProvider>
        </SettingsProvider>
        </AppAuthProvider>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
